import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getFriendsRequest } from '../friendsService';
import { FriendRequest } from '@/services/friends/friendsServicesTypes';

interface useGetFriendsRequestResult {
  data: { sent: FriendRequest[]; received: FriendRequest[] };
}

const useGetFriendsRequest = (): UseQueryResult<useGetFriendsRequestResult, Error> => {
  return useQuery<useGetFriendsRequestResult, Error>({
    queryKey: ['friendsRequest'],
    queryFn: getFriendsRequest,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
};

export default useGetFriendsRequest;
